import React from 'react';
import CreateSubmissionOnBehalf from './CreateSubmissionOnBehalf';
import { PageWrapper } from '../../styledComponents/wrappers';

/** The create-submission form on the desktop route, inside the standard page wrapper. */
const CreateSubmissionDesktop: React.FC = () => (
  <PageWrapper style={{ overflow: 'hidden' }}>
    <CreateSubmissionOnBehalf />
  </PageWrapper>
);

export default CreateSubmissionDesktop;
